<template>
  <!-- <router-link
    :to="{ path: '/' + Id +'/' + ApiKey + '/' + Os + '/' + Country + '/?'+ ADV_ID +'&cval='+Cval + LANG + OPTIONAL_PARAMS }"
  > -->
    <div v-if="show" class="smallcard-wrapper"
      :style="styleObject">
      <!-- <img v-if="Advertorial && false" class="advcover animated fadeInDown" :src="Advertorial" alt /> -->
      <div class="grid-container mb-3" @click="open()">
        <!-- <lottie-player class="mImg maxImgSize" alt="Card Image"
          src="https://assets8.lottiefiles.com/datafiles/h0nzHRXbLkn8WXm/data.json" mode="bounce" background="transparent"  speed="0.8"  style="width: 100%; height: 100%;"  autoplay >
        </lottie-player> -->
        <img v-if="id == 'newsletter'" class="mImg maxImgSize" src="@/assets/mail-icon.svg" alt="Card Image" />
        <img v-else class="mImg maxImgSize" src="http://myapptree.org/wp-content/uploads/2020/01/LogoSmallerhdpi.png" alt="Card Image" />
        <div class="mText">
          <p class="buttoncardtitle" v-html="title"></p>
          <p>
            <span style="font-size: 0.8rem!important">{{time}}</span>
          </p>
        </div>
        <button class="mButton">
          <div v-if="this.$cookie.get(id) == null">
            <span v-if="$route.query.style == 'myAppTree'" class="tree-coefficient">{{coins}}</span>
            <span v-else>{{coins}}</span>
            <img class="coin-logo img-responsive"/>
          </div>
          <div v-else>
            <img class="coin-logo img-responsive done" src="../assets/done.svg" />
          </div>
        </button>
      </div>
    </div>
</template>

<script>
const $ = window.$;

export default {
  name: "Card",
  data() {
    return {
      styleObject:{
        transform: 'translate(0px,0px)',
        maxHeight: '6.1rem',
        overflowY: 'hidden',
        position: ''
      },
      show: true
    };
  },
  props: [
    "title",
    "url",
    "coins",
    "time",
    "type",
    "icon",
    "id"
  ],

  activated(){
    /* eslint-disable no-console*/
  },

  created() {
  
  },
  methods:{
    emit: function(eventname){
      this.$emit(eventname, this.Adv_id)
    },
    getSubtitle: function(element) {
      var subtitle = "";

      if (element.length != 0) {
        if (this.$route.query.lang) {
          element.forEach(el => {
            if (el.Language == this.$route.query.lang) subtitle = el.Subtitle;
          });
        } else subtitle = element[0].Subtitle;
      }

      return subtitle;
    },
    divideActions: function(actions) {
      if (actions.length > 0) return actions.split("|");
      else return null;
    },
    open: function(){
    //   // window.open(this.url)
    //   if(window.Android){
    //     window.Android.goToPlayStore(this.url);
    //   }else if(window.webkit){
    //     window.webkit.messageHandlers.iOS.postMessage({action: "openUrl", param2: this.url});  
    //   }else{
    //     window.open(this.url)
    //   }
       if(this.id === "newsletter" && !localStorage.mailNeverAgain && !this.isThanks){
         $('#newsletterformmodal').modal('show');
         this.show = false;
       }
    }
  },
  components:{

  }
};
</script>
<style scoped lang="scss">

  .grid-container{
    position: relative;
    max-height: 50%;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    /* background-color: white; */
    /* border-radius: 25px; */
  }

  .smallcard-wrapper{
    position: relative;
    /* max-height: 50%; */
    /* display: grid; */
    /* grid-template-columns: 3fr 1fr; */
    /* grid-template-rows: 2fr 1fr; */
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: white;
    border-radius: 25px;
    // -webkit-box-shadow: 5px 5px 10px rgba(190,190,190, 0.16), 5px 5px 10px rgba(190,190,190, 0.23);
    // -ms-box-shadow: 5px 5px 10px rgba(190,190,190, 0.16), 5px 5px 10px rgba(190,190,190, 0.23);
    // -o-box-shadow: 5px 5px 10px rgba(190,190,190, 0.16), 5px 5px 10px rgba(190,190,190, 0.23);
    // box-shadow: 5px 5px 10px rgba(190,190,190, 0.16), 5px 5px 10px rgba(190,190,190, 0.23);
    // margin: 3%;
    margin-left: 3%;
    margin-right: 3%;
    margin-bottom: 3%;
    // overflow: hidden;
    transition: all .5s cubic-bezier(.6,0,.45,1.2);
    // transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
    

    .advcover, .mText, .description, .actions-container{
      pointer-events: none;
    } 

    .submitB{
      border: none;
      position: relative!important;
      width: 95%!important;
      border-radius: 25px!important;
      padding: 4%!important;
      margin-bottom: 0.6rem;
    }

    .actions-container{
      margin-top: 2rem;
      margin-bottom: 2rem;
    }

    .description{
      text-align: left;
      margin-left: 1rem;
      margin-right: 1rem;
    }

    .description-clamp{
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 80%;
      overflow: hidden;
    }

    .maxImgSize{
      max-height: 6.1rem
    }

    // .icon-logo{
    //   display: none;
    // }

    // .advcover{

    // }

    .buttoncardtitle {
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 20px !important;
      max-height: 60px !important;
    }
  }

</style>